export const SEND_EMAIL_TA = "SEND_EMAIL_TA";
export const SEND_EMAIL_TA_SUCCES = "SEND_EMAIL_TA_SUCCES";
export const SEND_EMAIL_TA_FAILED = "SEND_EMAIL_TA_FAILED";

export const SEND_PEER_INVITATION = "SEND_PEER_INVITATION";
export const SEND_PEER_INVITATION_SUCCES = "SEND_PEER_INVITATION_SUCCES";
export const SEND_PEER_INVITATION_FAILED = "SEND_PEER_INVITATION_FAILED";

export const SEND_EMAIL_ON_USER_CREATION = "SEND_EMAIL_ON_USER_CREATION";



// WEBPACK FOOTER //
// ./src/modules/emails/constants.js